import { render, staticRenderFns } from "./LifeEstimateResult.vue?vue&type=template&id=14490050&scoped=true&"
import script from "./LifeEstimateResult.vue?vue&type=script&lang=js&"
export * from "./LifeEstimateResult.vue?vue&type=script&lang=js&"
import style0 from "./LifeEstimateResult.vue?vue&type=style&index=0&id=14490050&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14490050",
  null
  
)

export default component.exports